import _ from 'lodash';
import React from 'react';
import CreditNoteSentFilter from '~/components/filters/CreditNoteSentFilter';
import CreditNoteStatusFilter from '~/components/filters/CreditNoteStatusFilter';

export default function CreditNoteFiltersBar({ filters, onChange }) {
  return (
    <>
      {!_.isEmpty(filters.creditNoteStatuses) && (
        <CreditNoteStatusFilter
          value={filters.creditNoteStatuses}
          onChange={({ target: { value } }) => onChange({ creditNoteStatuses: value })}
        />
      )}

      {!_.isEmpty(filters.creditNoteSent) && (
        <CreditNoteSentFilter
          value={filters.creditNoteSent}
          onChange={({ target: { value } }) => onChange({ creditNoteSent: value })}
        />
      )}
    </>
  );
}
